import { render, staticRenderFns } from "./channel-list.vue?vue&type=template&id=7e9d12ac&"
import script from "./channel-list.vue?vue&type=script&lang=js&"
export * from "./channel-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports